import { useQueryClient } from '@tanstack/react-query';
import { useWsEvent } from '@/realtime';
import { toast } from '@/stores/toasts';
import { afterKeys } from './api';
import type { Notes, RecapView } from './types';

/**
 * App-wide listener for the after-the-date moments (SPEC_V9 §C): a mutual
 * second-date yes and a note unlocking in the morning reach you wherever
 * you are. Nothing else about the second-date question is ever sent.
 */
export function AfterDateHost() {
  const qc = useQueryClient();
  useWsEvent('date.second.matched', (d) => {
    if (!d?.second) return;
    qc.setQueryData(afterKeys.second(d.session_id), d.second);
    void qc.invalidateQueries({ queryKey: afterKeys.journal });
    void qc.invalidateQueries({ queryKey: afterKeys.entry(d.session_id) });
    const name = d.second.match?.user.first_name;
    toast.people('You both want a second date', name ? `You and ${name} both said yes. Pick a time from My dates.` : undefined);
  });
  useWsEvent('date.recap.consent', (d) => {
    if (d?.consent) qc.setQueryData<RecapView>(afterKeys.recap(d.session_id), (p) => (p ? { ...p, consent: d.consent } : p));
  });
  useWsEvent('date.note.unlocked', (d) => {
    const n = d?.note;
    if (!n) return;
    qc.setQueryData<Notes>(afterKeys.notes, (p) => (p ? { ...p, received: [n, ...p.received.filter((x) => x.id !== n.id)] } : p));
    void qc.invalidateQueries({ queryKey: afterKeys.journal });
    toast.success('Open your note from last night', `${n.person.first_name} left you one line. It’s in My dates.`);
  });
  return null;
}
